import(/* webpackMode: "eager" */ "/home/runner/work/play/play/src/app/error.tsx");
